import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EntityService } from '../../services/entity.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationService } from '../../services/notification.service';
import { User } from '../../interfaces/user.interface';
import { EditUserModalComponent } from './edit-user-modal/edit-user-modal.component';
import { ConfirmationModalComponent } from '../../shared/confirmation-modal/confirmation-modal.component';
import { getCurrentUser } from '../../shared/utils/auth.utils';

@Component({
  selector: 'app-admin-users',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './admin-users.component.html',
  styleUrls: ['./admin-users.component.scss']
})
export class AdminUsersComponent implements OnInit {
  users: User[] = [];
  loading = false;
  private userPermissions: string[] = [];

  constructor(
    private entityService: EntityService,
    private modalService: NgbModal,
    private notificationService: NotificationService
  ) {
    const currentUser = getCurrentUser();
    if (currentUser && currentUser.permissions) {
      this.userPermissions = currentUser.permissions;
    }
  }

  ngOnInit() {
    this.loadUsers();
  }

  hasAnyPermission(permissions: string[]): boolean {
    if (!this.userPermissions || this.userPermissions.length === 0) return false;
    return permissions.some(permission => this.userPermissions.includes(permission));
  }

  loadUsers() {
    this.loading = true;
    this.entityService.getDatas('/admin/admins').subscribe({
      next: (response: any) => {
        this.loading = false;
        this.users = response;
        console.log('Utilisateurs chargés:', this.users);
      },
      error: (error) => {
        console.error('Erreur lors du chargement des Utilisateurs:', error);
        this.loading = false;
        this.notificationService.error('Erreur lors du chargement des Utilisateurs');
      }
    });
  }

  addUser() {
    const modalRef = this.modalService.open(EditUserModalComponent, {
      size: 'lg',
      centered: true
    });

    modalRef.result.then((result) => {
      if (result) {
        this.entityService.saveData('/admin/create-admin', result).subscribe({
          next: () => {
            this.notificationService.success('Administrateur ajouté avec succès');
            this.loadUsers();
          },
          error: (error) => {
            console.error('Erreur lors de l\'ajout:', error);
            this.notificationService.error('Erreur lors de l\'ajout de l\'administrateur');
          }
        });
      }
    }).catch(() => {});
  }

  editUser(user: User) {
    const modalRef = this.modalService.open(EditUserModalComponent, {
      size: 'lg',
      centered: true,
      backdrop: 'static',
      keyboard: false,
      windowClass: 'modal-edit-user'
    });
    modalRef.componentInstance.user = {...user};

    modalRef.result.then((result) => {
      if (result) {
        setTimeout(() => {
          this.loadUsers();
        }, 100);
      }
    }).catch((reason) => {
      if (reason) {
        setTimeout(() => {
          this.loadUsers();
        }, 100);
      }
    });
  }

  deleteUser(user: User) {
    const modalRef = this.modalService.open(ConfirmationModalComponent, {
      size: 'sm',
      centered: true
    });
    modalRef.componentInstance.message = 'Êtes-vous sûr de vouloir supprimer cet administrateur ?';
    modalRef.componentInstance.title = 'Confirmation de suppression';

    modalRef.result.then((result) => {
      if (result) {
        this.entityService.deleteData('/admin/admins', user.id).subscribe({
          next: () => {
            this.notificationService.success('Administrateur supprimé avec succès');
            this.loadUsers();
          },
          error: (error) => {
            console.error('Erreur lors de la suppression:', error);
            this.notificationService.error('Erreur lors de la suppression de l\'administrateur');
          }
        });
      }
    }).catch(() => {});
  }
} 